<template>
    <ul>
        <li :class="{'active': selected == 1}"
            @click="goTo('/',1)">
            <a href="javascript:void(0)">Accueil</a>
        </li>
        <li :class="{'active': selected == 2}"
            @click="goTo('/multitrade/fonctionnalités',2)">
            <a href="javascript:void(0)">Fonctionnalités</a>
        </li>
        <li :class="{'active': selected == 3}"
            @click="goTo('/multitrade/services',3)">
            <a href="javascript:void(0)">Services</a>
        </li>
        <li :class="{'active': selected == 4}"
            @click="goTo('/multitrade/vos-idees',4)">
            <a href="javascript:void(0)">Vos idées</a>
        </li>
        <li :class="{'active': selected == 5}"
            @click="goTo('/multitrade/capture',5)">
            <a href="javascript:void(0)">Captures</a>
        </li>
        <li :class="{'active': selected == 6}"
            @click="goTo('/multitrade/references',6)">
            <a href="javascript:void(0)">Références</a>
        </li>
        <li :class="{'active': selected == 7}"
            @click="goTo('/multitrade/contact',7)">
            <a href="javascript:void(0)">Contact</a>
        </li>
        <li class="versions-cta d-none d-lg-inline-flex">
            <a href="https://newness.ovh/multitrade" target="_blank" rel="noopener" class="pill">
                <i class="ion-ios-cloud-download"></i>
                Versions
                <span class="ext">↗</span>
            </a>
        </li>
    </ul>
</template>

<script>
    import {mapMutations, mapState} from "vuex";

    export default {
        name: "NavComponent",
        data(){
          return {
              selected: 1
          }
        },
        computed:{
            ...mapState({
                show: (state) => state.other.show
            })
        },
        methods:{
            ...mapMutations('other',['setShow']),
            goTo(path,index){
                this.selected = index
                if(this.show){
                    this.setShow(!this.show)
                }
                this.$router.push({path: path})
            }
        }
    }
</script>

<style scoped>
/* Ensure nav items align vertically */
ul {
  display: flex;
  align-items: center;
}
/* Versions CTA pill */
.versions-cta {
  margin-left: 12px;
  display: flex;
  align-items: center;
}
.versions-cta .pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 38px; /* match typical nav height */
  padding: 0 14px;
  border-radius: 9999px;
  color: #ffffff;
  background: linear-gradient(135deg, #44D36F 0%, #1abc9c 50%, #16a085 100%);
  box-shadow: 0 6px 20px rgba(22, 160, 133, 0.35), 0 2px 6px rgba(0,0,0,0.12);
  transform: translateY(0);
  transition: transform .15s ease, box-shadow .2s ease, filter .2s ease;
}
.versions-cta .pill:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 24px rgba(22, 160, 133, 0.45), 0 4px 10px rgba(0,0,0,0.12);
  filter: brightness(1.04);
}
.versions-cta .pill:active { transform: translateY(0); }
.versions-cta .pill .ext { opacity: .9; font-size: 12px; }
</style>